"use strict";
function getFieldValidity(state) {
  switch (true) {
    case state.disabled: {
      return null;
    }
    case state.invalid: {
      return "invalid";
    }
    case state.hasWarning: {
      return "warning";
    }
    case state.showValid: {
      return "valid";
    }
    default: {
      return null;
    }
  }
}
export {
  getFieldValidity
};
